'use strict';

var defaults = require('../../defaults/Defaults');
var idbKeyval = require('idb-keyval');
var log = require('../../log/Log').channel('OfflineStateSaverService');
var shajs = require('sha.js');
var stringify = require('json-stable-stringify');
var sutl = require('../../sutl/Sutl');

angular.module('inara').factory('OfflineStateSaverService', OfflineStateSaverService);

OfflineStateSaverService.$inject = [ '$timeout', 'KayleeService', 'RoomService' ];

function OfflineStateSaverService($timeout, KayleeService, RoomService) {
    var kayleeUpdatedTimeout = null;
    var sha256Sum = null;

    log.debug('starting');

    KayleeService.isInitialized()
    .then(function() {
        KayleeService.onUpdate(onKayleeUpdated);
    });

    return {
    };

    function objToString(obj, excl) {
        var keys = Object.keys(obj).sort();
        var str = '';

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key.charAt(0) === '$' ||
                typeof key === 'function' ||
                excl.includes(key)) continue;
            if (key === 'visualTheme') {
                str += stringify(obj[key].key);
            } else {
                str += stringify(obj[key]);
            }
        }

        return str;
    }

    function onKayleeUpdated() {
        if (!KayleeService.isWorkingOnline() ||
            kayleeUpdatedTimeout !== null) return;

        kayleeUpdatedTimeout = $timeout(onKayleeUpdatedTimeout, 10000);
    }

    function onKayleeUpdatedTimeout() {
        kayleeUpdatedTimeout = null;

        if (!KayleeService.isWorkingOnline()) return;
        if (!RoomService.isControllerLoaded()) return;

        var controller = RoomService.getController();
        var sha256Stream = new shajs.sha256();

        if (controller.$isPaired()) {
            if (!RoomService.isRoomLoaded()) return;

            var room = RoomService.getRoom();
            var i;

            sha256Stream.update(controller.roomId);
            sha256Stream.update(controller.language);            
            sha256Stream.update(objToString(sutl.getNode(RoomService.getController(), [ 'settings' ], {}), []));
            sha256Stream.update(objToString(KayleeService.getCompany(room.companyId), [ 'results' ]));
            sha256Stream.update(objToString(KayleeService.getSite(room.siteId), []));
            sha256Stream.update(objToString(room, [ 'caps', 'configuredCaps', 'results', 'states' ]));

            var equipment = room.$getEquipment();

            for (i = 0; i < equipment.length; i++) {
                var eq = equipment[i];
                sha256Stream.update(objToString(eq, [ 'connectState', 'firmwareVersion', 'lampOperationTime', 'modelNumber' ]));
                var eqStorage = eq.$getStorage();
                if (eqStorage) sha256Stream.update(objToString(eqStorage, []));
            }

            var calls = room.$getCalls(defaults.inara.numRecentCalls);

            for (i = 0; i < calls.length; i++) {
                sha256Stream.update(objToString(calls[i], []));
            }

            var directory = room.$getDirectory();

            for (i = 0; i < directory.length; i++) {
                sha256Stream.update(objToString(directory[i], []));
            }

            sha256Stream.update(objToString(room.$getCalendar(), [ 'office365Info' ]));

            sha256Stream.update(objToString(KayleeService.getRoomConfig(room.$id), []));
        } else {
            sha256Stream.update('unpaired');
        }

        var newSha256Sum = sha256Stream.digest('hex');

        if (newSha256Sum !== sha256Sum) {
            log.info('settings changed; saving state for offline use');
            sha256Sum = newSha256Sum;
            idbKeyval.set('kayleeCache', KayleeService.getCache());
        }
    }
}

module.exports = OfflineStateSaverService;
